import { oc } from '@orpc/contract';
import { listDocumentsInputSchema, listDocumentsOutputSchema } from '../schemas/documents.schemas.js';
/**
 * The vehicle's **current** documents. A row that has been replaced is not listed — its successor
 * carries `replacesId` — so the grid always shows one file per slot (PP §8).
 */
export const listDocumentsContract = oc
    .route({
    method: 'GET',
    path: '/vehicles/{vehicleId}/documents',
    tags: ['Documents'],
    summary: 'List the current documents attached to a stock vehicle',
})
    .input(listDocumentsInputSchema)
    .output(listDocumentsOutputSchema);
//# sourceMappingURL=list-documents.contract.js.map